import { Link } from 'react-router-dom'

/** The logo mark stands alone: it has no text lockup anywhere in the product. */
export function LandingNav() {
  return (
    <header className="absolute inset-x-0 top-0 z-20 text-carbonBlack">
      <div className="l-frame l-small flex h-[72px] items-center justify-between gap-6 font-medium">
        <Link to="/" aria-label="SitRepp home" className="shrink-0">
          <img src="/favicon.png" alt="" className="h-9 w-auto" />
        </Link>

        <nav aria-label="Main" className="flex items-center gap-6">
          <a href="#pricing" className="l-link hidden sm:inline">
            Pricing
          </a>
          <Link to="/about" className="l-link hidden sm:inline">
            About
          </Link>
          <Link to="/login" className="l-link">
            Sign in
          </Link>
        </nav>
      </div>
    </header>
  )
}
